var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.data && _vm.props.data.value)?_c('i',{staticClass:"fa fa-check"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }